import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})

export class FooterComponent{
    copyrightYear: string;
    constructor(){

    }
    ngOnInit(){
        const currentYear = new Date().getFullYear(); // e.g. 2025
    const nextYearShort = (currentYear + 1).toString().slice(-2); // e.g. 26
    this.copyrightYear = `${currentYear}-${nextYearShort}`;
    
}
}
